import Domain from 'helpers/Domain';
import { AA_BASE_PATH as basePath } from 'vue/constants/svodRoutes';
import { FLOW_TYPE } from 'models/FlowModel';
import { initializeEndcardTrackingData } from 'helpers/trackingOM';

const stateConfig = {
    RENDEZVOUS_SIGNIN: {
        pageTitle: 'Login to Stream Live TV, Sports, News and On Demand with Paramount+',
        basePath: '/activate/',
        pageType: 'rendezvous_activation_enter_code',
    },
    FORGOT_PASSWORD: {
        pageType: 'svod_forgotpassword',
    },
    REVIEW: {
        pageTitle: 'Paramount+ Subscription Payment Review',
        pageType: 'svod_payment_review',
    },
};

export const USER_LOGIN_TYPE = Object.freeze({
    [FLOW_TYPE.OAUTH_SHOWTIME]: 'aa-showtime',
    PARTNER_AUTH: 'partnerAuth',
});

export const USER_REG_TYPE = Object.freeze({
    STANDARD: 'standard',
    LIVE_TV: 'mvpd',
    RENDEZVOUS: 'rendezvous',
    GIFT: 'gift',
    EDU: 'student',
    CBS_SPORTS: 'cbssports_rendezvous',
});

export const APP_LOG_TYPE = Object.freeze({
    PURCHASE_ERROR: 'Process payment error',
    EDIT_PAYMENT_ERROR: 'Edit Payment Error',
    UPDATE_PAYMENT_FORM_ERROR: 'Update Payment Form Error',
    RESET_PWD_ERROR: 'Reset Password error',
    SIGN_UP_ERROR: 'Sign Up Error',
    NO_AUTH_N: 'NoAuthN',
    NO_AUTH_Z: 'NoAuthZ',
    RECURLY: 'Recurly setup',
    APP_LOG_TEXT: 'The code is not valid. Please try again.',
    APP_LOG_ERROR_TYPE: 'authentication error',
});

export const ACTION_NAMES = Object.freeze({
    ACTIVATION_FAILURE: 'trackActivationFailure',
    ACTIVATION_SUCCESS: 'trackActivationSuccess',
    ACTIVATION: 'trackActivation',
    ANNUAL_UPGRADE_TOGGLE: 'trackAnnualUpgradeToggle',
    APP_LOG: 'trackAppLog',
    CBS_SPORTS_GO_BACK: 'trackGoBackCbsSports',
    CONFIRMATION_SIGNIN: 'trackSignIn',
    CONFIRMATION_SIGNUP: 'trackSignUp',
    CREDIT_CARD_CANCEL: 'trackUpdateCreditCardCancel',
    CREDIT_CARD_SUBMIT_UPDATE: 'trackUpdateCreditCardSubmit',
    FORGOT_PASSWORD_CANCEL: 'trackForgotPassword-Cancel',
    FORGOT_PASSWORD_CTA: 'trackForgotPassword-SendEmail',
    FORGOT_PASSWORD_REDIRECT_LINK: 'trackForgotPassword-click_here_DoNotWaitForRedirect',
    GIFT_GO_BACK: 'trackGiftCardGoBack',
    REDEEM_GIFT_CARD: 'trackRedeemGiftCard',
    GIFT_CARD_REDEEM: 'trackGiftCardRedeem',
    GIFT_LEARN_MORE: 'trackGiftCardLearnMore',
    LEARN_MORE_CTA: 'trackLearnMoreCTA',
    LOGIN_CONTINUE: 'trackLoginContinue',
    LOGIN_SIGNOUT: 'trackLoginSignOut',
    LOGIN_SUCCESS: 'trackLoginSuccess',
    LOGIN: 'trackLogin',
    LOGIN_FAIL: 'trackLoginFail',
    NEW_REGISTRATION: 'trackRegistrationNew',
    PAYMENT_COMPLETE: 'trackPaymentComplete',
    PICK_PLAN_SELECTION: 'trackPickPlanSelection',
    REDEEM_OFFER: 'trackRedeemOffer',
    TRACK_EXISITING_GIFT_CARD_SUBSCRIBER: 'trackExisitingGiftCardSubscriber',
    REDEEM_VERIFY: 'trackRedeemOfferVerify',
    SIGN_IN_FORGOT_PASSWORD: 'trackForgotPassword',
    SIGN_IN_LIVE_TV: 'trackSignInWithTvProvider',
    SIGN_UP_NON_NATIVE_RENDEZVOUS: 'trackSignUp',
    TV_PROVIDER_FAIL: 'trackTvProviderFail',
    TV_PROVIDER_MORE: 'trackTvProviderSearchMore',
    TV_PROVIDER_SELECTION: 'trackTvProviderSelection',
    TV_PROVIDER_SUCCESS: 'trackTvProviderSuccess',
    UPGRADE_ANNUAL_PAYMENT_PAGE: 'trackUpgradeAnnualPaymentPage',
    MARKETING_CHECKBOX_SELECT: 'trackMarketingCheckboxSelect',
    MARKETING_CHECKBOX_DESELECT: 'trackMarketingCheckboxDeselect',
    TC_CHECKBOX_SELECT: 'trackTcCheckboxSelect',
    TC_CHECKBOX_DESELECT: 'trackTcCheckboxDeselect',
    TRACK_CANCEL_EDIT_PASSWORD: 'trackCancelEditPassword',
    TRACK_RESET_PASSWORD: 'trackResetPassword',
    SHOWHIDE_PASSWORD_SHOW: 'trackShowPassword',
    SHOWHIDE_PASSWORD_HIDE: 'trackHidePassword',
    LOGIN_FAILURE: 'trackLoginFailure',
    TRACK_RESET_PASSWORD_SUCCESS: 'trackResetPasswordSuccess',
    TRACK_CHANGE_YOUR_PLAN: 'trackChangeYourPlan',
    TRACK_SWITCH_PLAN: 'trackSwitchPlan',
    PAYMENT_METHOD_SELECTED: 'trackPaymentMethodTabSelect',
    PAYPAL_CHECKOUT_BUTTON: 'trackCheckoutPaypalButtonSelect',
    TRACK_EDIT_PAYMENT: 'trackEditPayment',
    UPDATE_PAYPAL_SUCCESS: 'trackUpdatePaypalSuccess',
    // START TEST PLOCTOPLUS-2947 Annual Plan Emphasis on PAP Adjusted Pricing Display and Hierarchy
    TRACK_PICK_PLAN_MODAL_VIEW: 'trackPickPlanModalView',
    TRACK_PICK_PLAN_MODAL_ABANDON: 'trackPickPlanModalAbandon',
    TRACK_PICK_PLAN_MODAL_SELECTION: 'trackPickPlanModalSelection',
    TRACK_UPDATE_PAYMENT_METHOD: 'trackUpdatePaymentMethod',
    TRACK_UPDATE_PAYMENT_METHOD_CANCEL: 'trackUpdatePaymentMethodCancel',
    TRACK_UPDATE_PAYMENT_METHOD_SUCCESS: 'trackUpdatePaymentMethodSuccess',
    TRACK_ACCOUNT_DELETION_SUCCESS: 'trackAccountDeletionSuccess',
    TRACK_ACCOUNT_DELETION_ERROR: 'trackAccountDeletionError',
    TRACK_APP_LOG: 'trackAppLog',
    // END TEST PLOCTOPLUS-2947 Annual Plan Emphasis on PAP Adjusted Pricing Display and Hierarchy
    SWITCH_TO_PAYPAL: 'trackSwitchtoPaypalButtonSelect',
    RESUME_PLAN_CTA: 'trackResumePlanCta',
    RESUME_PLAN_SUCCESS: 'trackResumePlanSuccess',
    TRY_IT_FREE: 'trackTryItFreeCTA',
});

export const F_TAGS = Object.freeze({
    CBS_SPORTS_SIGN_UP: 'AAM-00-10aih2j',
});

export const SCREEN_NAMES = Object.freeze({
    CONFIRMATION_SCREEN: '/tv-provider/nolinkaccount',
    TV_PROVIDER_SELECTION_SCREEN: '/tv-provider/select',
});

export const PAGE_TYPES = Object.freeze({
    CONFIRMATION_NO_ACCOUNT: 'tv-provider_nolinkaccount',
    SIGNIN: 'svod_signin',
    SIGNUP: 'svod_signup',
    EDU: 'svod_edu',
    TV_PROVIDER_SELECTION_SCREEN: 'tv-provider_select',
    ACTIVATION_PAGE: 'rendezvous_activation_enter_code',
    LOGIN_OPTIONS: 'rendezvous_activation_signin',
    EXPLAINER_PAGE: 'rendezvous_explainer',
    COMPLETE_PAGE: 'rendezvous_activation_complete',
    ACCOUNT: 'account',
    ACCOUNT_UPDATE_PAYMENT: 'account_updatepayment',
    PLAN_CHANGE_CONFIRMATION: 'Svod_planchangeconfirmation',
});

export const PAGE_NAMES = Object.freeze({
    SIGNUP: '/signup/',
    ACCOUNT: '/account/',
});

function Tracking() {
    let inter;
    let localArgs;

    return {
        name: 'Tracking Name',
        queueActions: [],
        trackStateFired: false,

        persistState: function (tags) {
            try {
                if (
                    utag_data &&
                    typeof utag_data === 'object' &&
                    tags &&
                    typeof tags === 'object'
                ) {
                    Object.assign(utag_data, tags);
                }
            } catch (e) {}
        },

        //om.trackState()
        trackState: function (args, persistTags) {
            try {
                if (persistTags && typeof persistTags === 'object') {
                    this.persistState(persistTags);
                    Object.assign(args, persistTags);
                }

                let state = this.getState(args);
                let brazeImportPromise;

                if (CBS.Registry.Features.braze_sdk === true) {
                    brazeImportPromise = import('helpers/brazePushTracking');
                    brazeImportPromise.then((brazePushTracking) => {
                        const brazeTrackingObj = new brazePushTracking.default();
                        state = brazeTrackingObj.appendTrackingData(state);
                        return brazeTrackingObj;
                    });
                }

                if (typeof om !== 'undefined') {
                    if (Domain.isDomestic()) clearInterval(inter);
                    om.trackState(Object.assign(state, initializeEndcardTrackingData));

                    if (CBS.Registry.Features.braze_sdk === true)
                        brazeImportPromise.then((brazePushTracking) => {
                            const brazeTrackingObj = new brazePushTracking.default();
                            brazeTrackingObj.removeParamsFromUrl();
                            return brazeTrackingObj;
                        });

                    // Workaround for outdated page utag_data on trackAction calls
                    if (utag_data && typeof utag_data === 'object' && state) {
                        Object.assign(utag_data, state);
                    }
                    this.trackStateFired = true;
                    this.trackQueuedActions();
                } else {
                    inter = setTimeout(() => {
                        this.trackState(args);
                    }, 5e2);
                }
            } catch (e) {
                console.error(e);
                // console.error('failed to track step')
            }
        },

        trackQueuedActions: function () {
            this.queueActions.forEach((args) => {
                this.trackAction(...args);
            });
            // reset
            this.queueActions = [];
        },

        //om.trackAction()
        trackAction: function (strOrObj = '', obj = {}, persistTags = null) {
            if (!this.trackStateFired) {
                this.queueActions.push(arguments);
                return;
            }

            if (typeof om !== 'undefined') {
                try {
                    if (persistTags && typeof persistTags === 'object') {
                        this.persistState(persistTags);
                        Object.assign(obj, persistTags);
                    }
                    om.trackAction(strOrObj, obj);
                } catch (e) {
                    console.error(e);
                }
            } else {
                inter = setTimeout(() => {
                    this.trackAction(strOrObj, obj);
                }, 5e2);
            }
        },

        /**
         * @deprecated
         *
         * @param user
         * @param userLoginType
         * @param payload
         * @param partner
         * @param activationCode
         */
        trackLogin(
            user,
            userLoginType = USER_REG_TYPE.STANDARD,
            payload = {},
            partner,
            activationCode,
            flowType,
        ) {
            this.persistState(user.tags);
            let svod = {};

            if (user.svod && typeof user.svod === 'object') {
                svod = {
                    userStatus: user.svod.package_status,
                    userType: user.svod.status,
                };
            }
            if (flowType === FLOW_TYPE.GIFT) {
                userLoginType = 'gift';
            } else {
                userLoginType = Domain.isDomestic() ? USER_REG_TYPE.RENDEZVOUS : userLoginType;
            }
            let trackingParams = Object.assign(
                svod,
                {
                    userRegId: user.regID,
                    userEventLoginSuccess: '1',
                    userLoginType,
                    ottActivationPartner: partner,
                    activationShortCode: activationCode,
                    pageType: flowType === FLOW_TYPE.GIFT ? 'svod_signin' : 'login',
                },
                payload,
            );

            try {
                this.trackAction(ACTION_NAMES.LOGIN_SUCCESS, trackingParams);
            } catch (e) {}
        },

        //om.trackRegistration()
        trackRegistration: function (
            user,
            userRegType = USER_REG_TYPE.STANDARD,
            partner,
            activationCode,
            marketCheckBox,
            marketingConsent,
            showHidePasswordStatus,
            payload = {},
        ) {
            try {
                const trackingParams = {
                    userType: 'Registered',
                    userStatus: 'sb|0',
                    userRegId: user.regID,
                    userEventRegistrationSuccess: '1',
                    userRegType,
                    pageType: 'svod_signup',
                    ottActivationPartner: partner,
                    activationShortCode: activationCode,
                    passIsVisible: showHidePasswordStatus,
                };

                if (USER_REG_TYPE.RENDEZVOUS) {
                    //removing login type for rendezvous - CBSENTWEB-2027
                    delete trackingParams.userLoginType;

                    // Adding new property activationDeviceFamily for rendezvous - PPIWEBM-971
                    if (Object.keys(payload).length !== 0) {
                        Object.assign(trackingParams, payload);
                    }
                }
                if (marketCheckBox) {
                    const { mktConsentStatus, tcConsentStatus } = marketCheckBox;
                    Object.assign(trackingParams, {
                        mktConsentStatus: mktConsentStatus,
                        tcConsentStatus: tcConsentStatus,
                    });
                }

                if (Domain.isDomestic()) {
                    Object.assign(trackingParams, {
                        marketingConsent: marketingConsent,
                    });
                }

                this.trackAction(ACTION_NAMES.NEW_REGISTRATION, trackingParams, user.tags);
            } catch (e) {}
        },

        trackPayment(trackingParams, persistTags = {}) {
            if (trackingParams && typeof trackingParams === 'object') {
                trackingParams.pageType = trackingParams.pageType || 'svod_complete';

                utag_data.userRegType = trackingParams.userRegType;

                if (trackingParams.partnerBundle) {
                    utag_data.partnerBundle = trackingParams.partnerBundle;
                }
                this.trackAction(ACTION_NAMES.PAYMENT_COMPLETE, trackingParams, persistTags);
                return false;
            }
        },

        //om.trackRedeemGiftCard()
        trackRedeemGiftCard: function (user) {
            try {
                const trackingParams = {
                    pageType: 'svod_gift',
                    userType: user.svod.status,
                    userStatus: user.svod.package_status,
                };
                om.trackAction(ACTION_NAMES.REDEEM_GIFT_CARD, trackingParams);
            } catch (e) {}
        },

        //om.trackGiftCardRedeem()
        trackGiftCardRedeem: function (user) {
            try {
                const trackingParams = {
                    pageType: 'svod_gift',
                    userRegType: 'gift',
                    userType: user.svod.status,
                    userStatus: user.svod.package_status,
                    giftCardRedeemOrderCompleteNew: '1',
                };
                om.trackAction(ACTION_NAMES.GIFT_CARD_REDEEM, trackingParams);
            } catch (e) {}
        },

        /**
         * Input array: ['signin', '' ,'continue']
         * Returns Pipe'd string for aa-link value: signup||continue|||||||
         *
         * @param val { array }
         *
         * @return { string }
         */
        aaLinkFilter: function (val) {
            if (Array.isArray(val)) {
                while (val.length < 10) {
                    val.push('');
                }
                return val.join('|');
            } else if (typeof val === 'string') {
                return val;
            } else {
                return null;
            }
        },

        /**
         * @param args
         * @returns {null|*}
         */
        getStateFromConfig(args) {
            if (args.name) {
                let state = stateConfig[args.name];

                if (state && typeof state === 'object') {
                    for (let [key, value] of Object.entries(args)) {
                        if (typeof value !== 'undefined') {
                            state[key] = value;
                        }
                    }

                    return state;
                }
            }

            return null;
        },

        /**
         * @param args
         * @returns {{}|*}
         */
        getState(args) {
            if (args && typeof args === 'object') {
                let state = this.getStateFromConfig(args) || args;

                if (state) {
                    if (!state.pageUrl) {
                        const serverDataEl = document.getElementById('app-config');
                        const serverData = !!serverDataEl
                            ? JSON.parse(serverDataEl.innerHTML)
                            : false;
                        let routePath = (typeof state.path !== 'string' ? '' : state.path).replace(
                            /^\//,
                            '',
                        );
                        let routeBasePath = state.basePath || basePath;

                        state['pageUrl'] =
                            window.location.protocol +
                            '//' +
                            window.location.host +
                            routeBasePath +
                            routePath;
                    }

                    try {
                        // remove keys used to get tracking config or determine pageUrl
                        delete state['name'];
                        delete state['path'];
                        delete state['basePath'];
                    } catch (e) {}

                    return state;
                }
            }

            return {};
        },
    };
}

export const tracking = new Tracking();
